/**
 * Site-wide footer
 */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { AppDownloadIcons } from 'components/AppDownloads';
import { LocaleSwitcherContainer } from 'components/LocaleSwitcher/LocaleSwitcherContainer';
export var Footer = function Footer(_ref) {
  var isBridgeApp = _ref.isBridgeApp,
      _ref$showFooter = _ref.showFooter,
      showFooter = _ref$showFooter === void 0 ? true : _ref$showFooter;
  return showFooter && React.createElement("footer", {
    className: "footer"
  }, React.createElement("div", {
    className: "wrap"
  }, React.createElement("div", {
    className: "footer__links__primary"
  }, React.createElement("div", {
    className: "grid"
  }, React.createElement("div", {
    className: "grid__item 1/2 md-1/4"
  }, React.createElement("h5", {
    className: "footer__header"
  }, React.createElement(FormattedMessage, {
    id: "footer.company",
    defaultMessage: "Company"
  })), React.createElement("ul", null, React.createElement("li", null, React.createElement(Link, {
    to: "/about",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.about-link",
    defaultMessage: "About us"
  }))), React.createElement("li", null, React.createElement(Link, {
    to: "/fitness"
  }, React.createElement(FormattedMessage, {
    id: "footer.fitness-link",
    defaultMessage: "Why studio fitness"
  }))), React.createElement("li", null, React.createElement(Link, {
    to: "/gifts"
  }, React.createElement(FormattedMessage, {
    id: "footer.gifts-link",
    defaultMessage: "Gifts"
  }))), React.createElement("li", null, React.createElement(Link, {
    to: "/about/careers",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.jobs-link",
    defaultMessage: "Careers"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "/press-room",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.press-link",
    defaultMessage: "Press"
  }))), React.createElement("li", null, React.createElement(Link, {
    to: "/go",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.classpass-go-link",
    defaultMessage: "ClassPass Go"
  }))), React.createElement("li", null, React.createElement(Link, {
    to: "/try/corporate",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.corporate",
    defaultMessage: "Corporate Memberships"
  }))))), React.createElement("div", {
    className: "grid__item 1/2 md-1/4"
  }, React.createElement("h5", {
    className: "footer__header"
  }, React.createElement(FormattedMessage, {
    id: "footer.support",
    defaultMessage: "Support"
  })), React.createElement("ul", null, React.createElement("li", null, React.createElement(Link, {
    to: "/contact",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.contact-link",
    defaultMessage: "Contact"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "//help.classpass.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "footer.help-center-link",
    defaultMessage: "Help Center"
  })))), !isBridgeApp && React.createElement(Fragment, null, React.createElement("h5", {
    className: "footer__header locale-switcher"
  }, React.createElement(FormattedMessage, {
    id: "footer.language",
    defaultMessage: "Language"
  })), React.createElement(LocaleSwitcherContainer, null))), React.createElement("div", {
    className: "grid__item 1/2 md-1/4"
  }, React.createElement("h5", {
    className: "footer__header"
  }, React.createElement(FormattedMessage, {
    id: "footer.partners",
    defaultMessage: "Partners"
  })), React.createElement("ul", null, React.createElement("li", null, React.createElement("a", {
    href: "//studios.classpass.com"
  }, React.createElement(FormattedMessage, {
    id: "footer.studios-link",
    defaultMessage: "Become a Partner"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "https://developers.classpass.com/spec"
  }, React.createElement(FormattedMessage, {
    id: "footer.open-api-spec-link",
    defaultMessage: "Integration API Docs"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "//afterclass.classpass.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "footer.studios-blog-link",
    defaultMessage: "After Class Blog"
  }))))), React.createElement("div", {
    className: "grid__item 1/2 md-1/4"
  }, React.createElement("h5", {
    className: "footer__header"
  }, React.createElement(FormattedMessage, {
    id: "footer.community",
    defaultMessage: "Community"
  })), React.createElement("ul", null, React.createElement("li", null, React.createElement("a", {
    href: "/blog",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.blog-link",
    defaultMessage: "Blog"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "/lists/cities",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.top-lists-link",
    defaultMessage: "Top 10 Lists"
  }))))))), React.createElement("div", {
    className: "footer__links__secondary"
  }, React.createElement("div", {
    className: "grid"
  }, React.createElement("div", {
    className: "grid__item md-1/2"
  }, React.createElement("h5", {
    className: "footer__header mt0"
  }, React.createElement(FormattedMessage, {
    id: "footer.downloads",
    defaultMessage: "Enjoy fitness on the go"
  })), React.createElement(AppDownloadIcons, {
    extraClass: "app-download-icons--small"
  })), React.createElement("div", {
    className: "grid__item md-1/2"
  }, React.createElement("div", {
    className: "footer__icons"
  }, React.createElement("ul", null, React.createElement("li", null, React.createElement("a", {
    className: "icon icon--28 icon--fb-white",
    href: "//www.facebook.com/classpass",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "service.facebook",
    defaultMessage: "Facebook"
  }))), React.createElement("li", null, React.createElement("a", {
    className: "icon icon--28 icon--tw-white",
    href: "//twitter.com/classpass",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "service.twitter",
    defaultMessage: "Twitter"
  }))), React.createElement("li", null, React.createElement("a", {
    className: "icon icon--28 icon--ig-white",
    href: "//instagram.com/classpass",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "service.instagram",
    defaultMessage: "Instagram"
  }))), React.createElement("li", null, React.createElement("a", {
    className: "icon icon--28 icon--pt-white",
    href: "//www.pinterest.com/classpass/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "service.pinterest",
    defaultMessage: "Pinterest"
  }))), React.createElement("li", null, React.createElement("a", {
    className: "icon icon--28 icon--sp-white",
    href: "//play.spotify.com/user/classpass/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "service.spotify",
    defaultMessage: "Spotify"
  }))), React.createElement("li", null, React.createElement("a", {
    className: "icon icon--28 icon--tb-white",
    href: "//classpass.tumblr.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(FormattedMessage, {
    id: "service.tumblr",
    defaultMessage: "Tumblr"
  })))), React.createElement("ul", {
    className: "footer__legal"
  }, React.createElement("li", null, React.createElement("a", {
    href: "/terms",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.terms-link",
    defaultMessage: "Terms of Use"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "/privacy",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.privacy-link",
    defaultMessage: "Privacy Policy"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "/privacy#cookies",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.cookies-link",
    defaultMessage: "Cookies & ads"
  }))), React.createElement("li", null, React.createElement("a", {
    href: "/about/accessibility",
    target: "_self"
  }, React.createElement(FormattedMessage, {
    id: "footer.accessibility-link",
    defaultMessage: "Accessibility"
  }))))))))));
};
Footer.propTypes = {
  showFooter: PropTypes.bool
};
export var mapStateToProps = function mapStateToProps(state) {
  return {
    showFooter: !state.page.reducedFooter
  };
};
export var FooterContainer = connect(mapStateToProps)(Footer);